import { Col, Row, Skeleton } from 'antd'
import { ScrollBar } from 'components/CommonStyles'
import React from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import ToggleThreeOptions from '../Toggle/ToggleThreeOptions'
import PlacementTable from './PlacementTable'
import {
  ColorDivider,
  PlacedTitle,
  PlacementBoxContainer,
  PlacementContainer,
  PlacementInnerContainer,
  PlacementTitle,
} from './style'
export default function PlacementHistory({
  placementHistoryData,
  handleStatusClick,
  handlePlacementHistoryChange,
  jobCandidateState,
  onFilterChange,
  placedAtObj,
  placedAt,
  loadMore,
  handleCollapseClick,
  placementData,
  getJobRolePreview,
  disabled,
  previewData
}) {
  const renderComponent = title => {
    return (
      <PlacementTable
        title={title}
        placementHistoryData={placementHistoryData}
        onPageChange={handlePlacementHistoryChange}
        jobCandidateState={jobCandidateState}
        onFilterChange={onFilterChange}
        handleCollapseClick={handleCollapseClick}
        placementData={placementData}
        getJobRolePreview={getJobRolePreview}
        placementHistoryTableLoading={
          jobCandidateState?.placementHistoryTableLoading
        }
        previewData={previewData}
        disabled={disabled}
      />
    )
  }
  const items = [
    {
      key: 'APPLIED',
      value: 'APPLIED',
      label: 'Applied',
      children: renderComponent('Applied'),
    },
    {
      key: 'MISSED',
      value: 'MISSED',
      label: 'Missed',
      children: renderComponent('Missed'),
    },
    {
      key: 'INELIGIBLE',
      value: 'INELIGIBLE',
      label: 'Ineligible',
      children: renderComponent('Ineligible'),
    },
  ]

  return (
    <PlacementContainer>
      <PlacementTitle>Placement History</PlacementTitle>
      <PlacementInnerContainer>
        {placedAt?.length > 0 ? (
          <PlacementBoxContainer>
            <PlacedTitle>Placed at</PlacedTitle>
            <ScrollBar
              id="scrollableElement"
              height={placedAt?.length >= 10 ? '28vh' : 'unset'}
            >
              <InfiniteScroll
                dataLength={placedAt?.length}
                next={loadMore}
                hasMore={
                  placedAtObj?.totalPages > jobCandidateState?.placedAtPageNo
                }
                loader={<Skeleton avatar paragraph={{ rows: 1 }} active />}
                scrollableTarget="scrollableElement"
              >
                {placedAt?.map((item, index) => {
                  return (
                    <div
                      key={index + 'placedAT'}
                      style={{ display: 'flex', gap: '1rem' }}
                    >
                      <PlacedTitle>
                        {item?.role?.rolePublishedBy == 'INSTITUTE'
                          ? item?.role?.company?.companyName
                          : item?.role?.corporate?.name}
                      </PlacedTitle>
                      <PlacedTitle fontWeight={400} color="#343E59">
                        {item?.role?.tittle}
                      </PlacedTitle>
                    </div>
                  )
                })}
              </InfiniteScroll>
            </ScrollBar>
          </PlacementBoxContainer>
        ) : null}
        {jobCandidateState?.status === 'MISSED' ? (
          <Row style={{ paddingBottom: 20 }} gutter={6}>
            <Col xs={8}>
              <ColorDivider color="#0FB680">Role application open</ColorDivider>
            </Col>
            <Col xs={10}>
              <ColorDivider color="#E35E50">
                Role application closed{' '}
              </ColorDivider>
            </Col>

            <Col xs={4}></Col>
          </Row>
        ) : null}
        <ToggleThreeOptions
          tabs={items}
          current={jobCandidateState?.status}
          handleClick={handleStatusClick}
          equalSpace
          width={'100%'}
          activeStyle={{
            background: 'rgb(242, 244, 255)',
            color: 'black',
            borderRadius: '0px',
            border: ' none',
            borderBottom: '3px solid rgb(50, 73, 215)',
            height: '43px',
            showBorderBetween: 1,
          }}
          alignText={'center'}
          normalTextColor={'#000'}
          normalFontWeight={400}
        />
        {renderComponent(jobCandidateState?.status)}
      </PlacementInnerContainer>
    </PlacementContainer>
  )
}
